import type { ReactNode } from 'react';

export const GivePageShell = ({
  children,
  footer,
  wide = false,
}: {
  children: ReactNode;
  footer?: ReactNode;
  wide?: boolean;
}) => (
  <div className="give-page">
    <div className={`give-page-inner${wide ? ' give-page-inner--wide' : ''}`}>
      <div className="give-page-main">{children}</div>
      {footer}
    </div>
  </div>
);
